(function () {
  'use strict';

  console.log('[Balanced] shipping-calculator.js v12 carregado');

  function cepToProvince(cep) {
    var n = parseInt(String(cep || '').replace(/\D/g, '').substring(0, 5), 10);

    if (isNaN(n)) return null;
    if (n <= 19999) return 'SP';
    if (n <= 28999) return 'RJ';
    if (n <= 29999) return 'ES';
    if (n <= 39999) return 'MG';
    if (n <= 48999) return 'BA';
    if (n <= 49999) return 'SE';
    if (n <= 56999) return 'PE';
    if (n <= 57999) return 'AL';
    if (n <= 58999) return 'PB';
    if (n <= 59999) return 'RN';
    if (n <= 63999) return 'CE';
    if (n <= 64999) return 'PI';
    if (n <= 65999) return 'MA';
    if (n <= 68899) return 'PA';
    if (n <= 68999) return 'AP';
    if (n <= 69299) return 'AM';
    if (n <= 69399) return 'RR';
    if (n <= 69899) return 'AM';
    if (n <= 69999) return 'AC';
    if (n <= 72799) return 'DF';
    if (n <= 72999) return 'GO';
    if (n <= 73699) return 'DF';
    if (n <= 76799) return 'GO';
    if (n <= 76999) return 'RO';
    if (n <= 77999) return 'TO';
    if (n <= 78899) return 'MT';
    if (n <= 78999) return 'RO';
    if (n <= 79999) return 'MS';
    if (n <= 87999) return 'PR';
    if (n <= 89999) return 'SC';
    if (n <= 99999) return 'RS';

    return null;
  }

  function formatBRL(value) {
    return value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function maskCEP(value) {
    var digits = String(value || '').replace(/\D/g, '').slice(0, 8);

    if (digits.length > 5) {
      return digits.slice(0, 5) + '-' + digits.slice(5);
    }

    return digits;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeText(value) {
    var text = String(value || '');

    if (text.normalize) {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return text.toLowerCase().trim();
  }

  function getRateLabel(rate) {
    return rate.presentment_name || rate.name || rate.title || 'Envio';
  }

  function getPriceNumber(rate) {
    var rawPrice = rate && rate.price;

    if (typeof rawPrice === 'number') {
      return rawPrice;
    }

    var text = String(rawPrice == null ? '' : rawPrice).trim();

    if (!text) {
      return 0;
    }

    text = text.replace(/[^\d,.-]/g, '');

    if (text.indexOf(',') !== -1) {
      text = text.replace(/\./g, '').replace(',', '.');
    }

    var number = parseFloat(text);

    if (isNaN(number)) {
      return 0;
    }

    return number;
  }

  function isFreeRate(rate) {
    var price = getPriceNumber(rate);
    var label = normalizeText(getRateLabel(rate));

    return price <= 0 || (
      label.indexOf('frete gratis') !== -1 ||
      label.indexOf('gratis') !== -1 ||
      label.indexOf('free shipping') !== -1 ||
      label.indexOf('free') !== -1
    );
  }

  function cleanRates(rates) {
    if (!Array.isArray(rates)) {
      return [];
    }

    /*
      Se vier "Frete grátis" junto com fretes pagos,
      remove o grátis para evitar promessa errada na PDP.
      Se vier apenas frete grátis, mantém e renderiza em 2 colunas.
    */
    var paidRates = rates.filter(function (rate) {
      return !isFreeRate(rate);
    });

    if (paidRates.length > 0) {
      return paidRates;
    }

    return rates;
  }

  function getDeliveryDays(rate) {
    var days = null;

    if (rate.delivery_days != null && !isNaN(parseInt(rate.delivery_days, 10))) {
      days = parseInt(rate.delivery_days, 10);
    } else if (rate.estimated_delivery_days != null && !isNaN(parseInt(rate.estimated_delivery_days, 10))) {
      days = parseInt(rate.estimated_delivery_days, 10);
    }

    if (days != null && days > 0) {
      return days + ' dias úteis';
    }

    if (rate.delivery_date) {
      return 'até ' + new Date(rate.delivery_date).toLocaleDateString('pt-BR');
    }

    return '';
  }

  function findVariantId(scope) {
    var productScope = scope.closest('product-info, section, .product, .product__info-wrapper') || document;

    var checkedInput = productScope.querySelector('input[name="id"]:checked');

    if (checkedInput && checkedInput.value) {
      return checkedInput.value;
    }

    var input = productScope.querySelector('input[name="id"], select[name="id"]');

    if (input && input.value) {
      return input.value;
    }

    var jsonScript = scope.querySelector('[data-shipping-variant-id]');

    if (jsonScript) {
      try {
        return JSON.parse(jsonScript.textContent);
      } catch (error) {}
    }

    return null;
  }

  function fetchJSON(url, options) {
    return fetch(url, Object.assign({
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }, options || {})).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (json) {
          throw new Error(json.description || json.message || ('HTTP ' + response.status));
        });
      }

      return response.json();
    });
  }

  function buildRatesUrl(zip, province) {
    return '/cart/shipping_rates.json'
      + '?shipping_address[zip]=' + encodeURIComponent(zip)
      + '&shipping_address[country]=BR'
      + '&shipping_address[province]=' + encodeURIComponent(province);
  }

  function pollRates(url, maxAttempts) {
    return new Promise(function (resolve) {
      var attempt = 0;

      function tick() {
        attempt++;

        fetch(url, {
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json'
          }
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            var rates = data && (data.shipping_rates || data.rates);

            if (Array.isArray(rates) && rates.length > 0) {
              resolve(rates);
              return;
            }

            if (attempt >= maxAttempts) {
              resolve(rates || []);
              return;
            }

            setTimeout(tick, 600);
          })
          .catch(function () {
            if (attempt >= maxAttempts) {
              resolve([]);
              return;
            }

            setTimeout(tick, 600);
          });
      }

      tick();
    });
  }

  function renderFreeRates(resultsEl, rates) {
    var rows = rates.map(function (rate) {
      return ''
        + '<tr>'
        + '<td>' + escapeHtml(getRateLabel(rate)) + '</td>'
        + '<td class="price free">' + escapeHtml('Grátis') + '</td>'
        + '</tr>';
    }).join('');

    resultsEl.innerHTML = ''
      + '<table class="shipping-calculator__table--free">'
      + '<thead>'
      + '<tr>'
      + '<th>Transportadora</th>'
      + '<th>Valor</th>'
      + '</tr>'
      + '</thead>'
      + '<tbody>'
      + rows
      + '</tbody>'
      + '</table>';

    resultsEl.hidden = false;
  }

  function renderPaidRates(resultsEl, rates) {
    var rows = rates.map(function (rate) {
      var price = getPriceNumber(rate);
      var priceLabel = price > 0 ? formatBRL(price) : 'Grátis';
      var priceClass = price > 0 ? 'price' : 'price free';
      var deliveryDays = getDeliveryDays(rate);

      return ''
        + '<tr>'
        + '<td>' + escapeHtml(getRateLabel(rate)) + '</td>'
        + '<td>' + escapeHtml(deliveryDays) + '</td>'
        + '<td class="' + priceClass + '">' + escapeHtml(priceLabel) + '</td>'
        + '</tr>';
    }).join('');

    resultsEl.innerHTML = ''
      + '<table class="shipping-calculator__table--paid">'
      + '<thead>'
      + '<tr>'
      + '<th>Transportadora</th>'
      + '<th>Prazo</th>'
      + '<th>Valor</th>'
      + '</tr>'
      + '</thead>'
      + '<tbody>'
      + rows
      + '</tbody>'
      + '</table>';

    resultsEl.hidden = false;
  }

  function renderRates(resultsEl, rates) {
    rates = cleanRates(rates);

    if (!Array.isArray(rates) || rates.length === 0) {
      return false;
    }

    rates.sort(function (a, b) {
      return getPriceNumber(a) - getPriceNumber(b);
    });

    var onlyFreeRates = rates.length > 0 && rates.every(function (rate) {
      return isFreeRate(rate);
    });

    if (onlyFreeRates) {
      renderFreeRates(resultsEl, rates);
      return true;
    }

    renderPaidRates(resultsEl, rates);
    return true;
  }

  function calculateShipping(scope) {
    var input = scope.querySelector('[data-shipping-zip]');
    var resultsEl = scope.querySelector('[data-shipping-results]');
    var errorEl = scope.querySelector('[data-shipping-error]');
    var button = scope.querySelector('[data-shipping-submit]');

    if (!input || !resultsEl || !errorEl || !button) {
      return;
    }

    var rawZip = String(input.value || '').replace(/\D/g, '');

    if (rawZip.length !== 8) {
      errorEl.textContent = 'CEP inválido. Digite os 8 dígitos.';
      errorEl.hidden = false;
      resultsEl.hidden = true;
      return;
    }

    var province = cepToProvince(rawZip);

    if (!province) {
      errorEl.textContent = 'Não foi possível identificar o estado pelo CEP.';
      errorEl.hidden = false;
      resultsEl.hidden = true;
      return;
    }

    var variantId = findVariantId(scope);

    if (!variantId) {
      errorEl.textContent = 'Não consegui identificar o produto. Recarregue a página e tente de novo.';
      errorEl.hidden = false;
      resultsEl.hidden = true;
      return;
    }

    errorEl.hidden = true;
    resultsEl.hidden = true;
    resultsEl.innerHTML = '';

    button.disabled = true;
    button.dataset.originalLabel = button.dataset.originalLabel || button.textContent;
    button.textContent = 'Calculando...';

    var addedKey = null;
    var maskedZip = maskCEP(rawZip);

    fetchJSON('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            '_shipping_calc': '1'
          }
        }]
      })
    })
      .then(function (response) {
        var added = (response.items && response.items[0]) || response;
        addedKey = added.key;

        return pollRates(buildRatesUrl(maskedZip, province), 8);
      })
      .then(function (rates) {
        var rendered = renderRates(resultsEl, rates);

        if (!rendered) {
          errorEl.textContent = 'Nenhuma forma de envio disponível para este CEP.';
          errorEl.hidden = false;
          resultsEl.hidden = true;
        }
      })
      .catch(function (error) {
        errorEl.textContent = error.message || 'Erro ao calcular o frete. Tente de novo em alguns segundos.';
        errorEl.hidden = false;
        resultsEl.hidden = true;
      })
      .then(function () {
        if (addedKey) {
          return fetchJSON('/cart/change.js', {
            method: 'POST',
            body: JSON.stringify({
              id: addedKey,
              quantity: 0
            })
          }).catch(function () {});
        }
      })
      .then(function () {
        button.disabled = false;
        button.textContent = button.dataset.originalLabel || 'Consultar';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
  }

  function init() {
    document.querySelectorAll('[data-shipping-calculator]').forEach(function (calculator) {
      if (calculator.dataset.balancedShippingInitialized === 'true') {
        return;
      }

      calculator.dataset.balancedShippingInitialized = 'true';

      var input = calculator.querySelector('[data-shipping-zip]');
      var form = calculator.querySelector('[data-shipping-form]');
      var button = calculator.querySelector('[data-shipping-submit]');

      if (input) {
        input.addEventListener('input', function () {
          input.value = maskCEP(input.value);
        });
      }

      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          calculateShipping(calculator);
        });
      }

      if (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          calculateShipping(calculator);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();